// src/components/CategoryMegaMenu.jsx
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { CATEGORY_CONFIG, getSubCategories } from '../config/categoryConfig';
import './CategoryMegaMenu.css';

export default function CategoryMegaMenu({ 
  availableCategories = [], 
  products = [], 
  onClose,
  triggerRef,
  onMouseEnter, // ← YENİ
  onMouseLeave  // ← YENİ
}) {
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  // Kategorilere göre ürün sayısını hesapla
  const getCategoryProductCount = (mainCategory) => {
    if (!products || products.length === 0) return 0;
    
    const count = products.filter(p => {
      if (!p.category) return false;
      const prodMainCat = p.category.includes(' > ') 
        ? p.category.split(' > ')[0] 
        : p.category;
      return prodMainCat === mainCategory;
    }).length;
    return count;
  };

  // Alt kategorileri ve ürün sayılarını hesapla
  const getSubCategoriesWithCount = (mainCategory) => {
    if (!products || products.length === 0) return [];
    
    const subCats = getSubCategories(mainCategory);
    const result = subCats.map(subCat => {
      const fullCat = `${mainCategory} > ${subCat}`;
      const count = products.filter(p => p.category === fullCat).length;
      return { name: subCat, count };
    }).filter(sc => sc.count > 0);
    return result;
  };

  // Mevcut kategorileri config'e göre filtrele
  const validCategories = availableCategories
    .filter(cat => CATEGORY_CONFIG[cat])
    .filter(mainCat => getCategoryProductCount(mainCat) > 0);

  // Menü pozisyonunu hesapla - Ekrana sığdır
  useEffect(() => {
    if (menuRef.current && triggerRef?.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const menuWidth = 950;
      const windowWidth = window.innerWidth;
      const padding = 20;

      let left = triggerRect.left + (triggerRect.width / 2);
      let top = triggerRect.bottom + 8; // ← 12'den 8'e düşürdük (daha yakın)

      // Sol kenara çok yakınsa sağa kaydır
      if (left - (menuWidth / 2) < padding) {
        left = padding + (menuWidth / 2);
      }

      // Sağ kenara çok yakınsa sola kaydır
      if (left + (menuWidth / 2) > windowWidth - padding) {
        left = windowWidth - padding - (menuWidth / 2);
      }

      setPosition({ top, left });
    }
  }, [triggerRef]);

  if (validCategories.length === 0) {
    return null;
  }

  const handleCategoryClick = (categoryPath) => {
    navigate(`/category/${encodeURIComponent(categoryPath)}`);
    // ← DEĞİŞTİ: onClose'u hemen çağırmıyoruz, 100ms bekletiyoruz
    setTimeout(() => {
      onClose();
    }, 100);
  };

  const menuContent = (
    <div 
      ref={menuRef}
      className="category-mega-menu-portal"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
      }}
      onMouseEnter={onMouseEnter} // ← YENİ: Parent'tan gelen fonksiyonu kullan
      onMouseLeave={onMouseLeave} // ← YENİ: Parent'tan gelen fonksiyonu kullan
    >
      <div className="category-mega-menu-container">
        <div className="category-mega-menu-grid">
          {validCategories.map(mainCat => {
            const catConfig = CATEGORY_CONFIG[mainCat];
            const subCatsWithCount = getSubCategoriesWithCount(mainCat);
            const totalCount = getCategoryProductCount(mainCat);
            
            return (
              <div key={mainCat} className="category-mega-menu-column">
                <div 
                  className="category-mega-menu-title"
                  onClick={() => handleCategoryClick(mainCat)}
                >
                  <span className="category-mega-menu-emoji">{catConfig.emoji}</span>
                  <span className="category-mega-menu-text">{mainCat}</span>
                  <span className="category-mega-menu-count">({totalCount})</span>
                </div>
                
                {subCatsWithCount.length > 0 && (
                  <ul className="category-mega-menu-list">
                    {subCatsWithCount.slice(0, 8).map(subCat => {
                      const subConfig = catConfig.subcategories[subCat.name];
                      return (
                        <li 
                          key={subCat.name}
                          onClick={() => handleCategoryClick(`${mainCat} > ${subCat.name}`)}
                        >
                          <span className="category-sub-emoji">{subConfig?.emoji || '•'}</span>
                          <span className="category-sub-text">{subCat.name}</span>
                          <span className="category-sub-count">({subCat.count})</span>
                        </li>
                      );
                    })}
                    {subCatsWithCount.length > 8 && (
                      <li 
                        className="category-view-all-sub" 
                        onClick={() => handleCategoryClick(mainCat)}
                      >
                        Tümünü Gör →
                      </li>
                    )}
                  </ul>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );

  return createPortal(menuContent, document.body);
}